import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { Group, Path, Line } from 'react-konva';

const default_color = '#000000';
const default_bg_color = '#FFFFFF';

const InstructionsHand = forwardRef((props, ref) => {
	const [ is_clicking, setIsClicking ] = useState(false);

	useImperativeHandle(ref, () => ({
		clickingHandOn() {
			setIsClicking(true);
		},

		clickingHandOff() {
			setIsClicking(false);
		},
	}), []);

	const scale = props?.scale ?? 1;
	const color = props?.color ?? default_color;
	const bg_color = props?.bg_color ?? default_bg_color;
	const normal_stroke_width = props?.normal_stroke_width ?? 2;
	const thin_stroke_width = props?.thin_stroke_width ?? Math.round(normal_stroke_width / 2);

	const normal_line_props = {
		strokeWidth:normal_stroke_width,
		stroke:color,
	};

	const thin_line_props = {
		strokeWidth:thin_stroke_width,
		stroke:color,
	};

	return (
		<Group scaleX={scale} scaleY={scale}>
			<Path
				data="M31.92,17.55l0-0.01l-2.02-2.02l-0.22,1.18c-1.77,0.03-3.19,1.48-3.19,3.26c0-1.8-1.46-3.27-3.25-3.27S20,18.16,20,19.96c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27V5.27c0-0.91-0.37-1.73-0.96-2.32l0,0L10.38,0.8L10.26,2c0,0-0.01,0-0.01,0C8.46,2,7,3.46,7,5.27v16.42c-2.87,0-5,1.14-5,3.91V36c0,0.24,0.02,0.48,0.05,0.71l-0.65,1.12l2.37,2.4c0,0,0,0,0,0l0,0h0C4.85,41.33,6.35,42,8,42h18.5c3.58,0,6.5-2.94,6.5-6.53V19.96C33,19,32.58,18.14,31.92,17.55z"
				fill={color}
				{...normal_line_props}
			/>

			<Path
				data="M24.5,40c3.58,0,6.5-2.94,6.5-6.53V17.96c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27c0-1.8-1.46-3.27-3.25-3.27S18,16.16,18,17.96c0-1.8-1.46-3.27-3.25-3.27s-3.25,1.46-3.25,3.27V3.27C11.5,1.46,10.04,0,8.25,0S5,1.46,5,3.27v16.42c-2.87,0-5,1.14-5,3.91V34c0,3.3,2.7,6,6,6H24.5z"
				fill={bg_color}
				{...normal_line_props}
			/>

			<Path
				data="M6.32,5.11c0.22-0.29,1-0.5,1.93-0.5c0.93,0,1.71,0.21,1.93,0.5v-3c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5V5.11z"
				{...thin_line_props}
			/>

			<Path
				data="M5,19.68v7.41c0,2.36-1.12,3.89-1.12,3.89"
				{...normal_line_props}
			/>

			<Line
				points={[11.5, 17.96, 11.5, 20.59]}
				{...normal_line_props}
			/>

			<Line
				points={[18, 17.96, 18, 20.59]}
				{...normal_line_props}
			/>

			<Line
				points={[24.5, 17.96, 24.5, 20.59]}
				{...normal_line_props}
			/>

			<Path
				data="M10.18,19.83c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				{...thin_line_props}
			/>

			<Path
				data="M16.68,19.83c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				{...thin_line_props}
			/>

			<Path
				data="M23.18,19.83c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				{...thin_line_props}
			/>

			<Path
				data="M29.77,19.83c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				{...thin_line_props}
			/>

			<Path
				data="M10.18,11.83c-0.22-0.86-1-1.5-1.93-1.5c-0.93,0-1.71,0.64-1.93,1.5"
				{...thin_line_props}
			/>

			{(is_clicking) && (
				<Group y={-4}>
					<Group>
						<Path
							data="M-1.61-6.61c2.76-2.03,6.17-3.23,9.86-3.23c9.2,0,16.67,7.46,16.67,16.67c0,2.25-0.45,4.4-1.26,6.36"
							strokeWidth={normal_stroke_width}
							stroke={color}
							lineCap="round"
						/>

						<Path
							data="M-2.18,19.83c-3.8-3.05-6.23-7.74-6.23-13c0-3.3,0.96-6.38,2.62-8.97"
							strokeWidth={normal_stroke_width}
							stroke={color}
							lineCap="round"
						/>
					</Group>

					<Group>
						<Path
							data="M-0.66,12.5c-1.04-1.64-1.65-3.58-1.65-5.67c0-5.83,4.73-10.56,10.56-10.56S18.81,1.01,18.81,6.83c0,1.91-0.5,3.69-1.39,5.24"
							strokeWidth={normal_stroke_width}
							stroke={color}
							lineCap="round"
						/>
					</Group>
				</Group>
			)}
		</Group>
	)
});

export default InstructionsHand;